import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import Layout, { PageHeader } from "../components/Layout";
import SEO from "../components/SEO";
import { Reveal } from "../components/motion";
import { StatusBadge } from "../components/StatusBadge";
import { IMAGES } from "../data/images";

const products = [
  {
    name: "EazyMS", to: "/eazyms", theme: "ms", status: "Live",
    tag: "Warehouse & Factory Management",
    img: IMAGES.coldRacks,
    desc: "Manage inventory, labour and dispatch as one operating system on the floor — the product layer of managed operations.",
  },
  {
    name: "EazyOS", to: "/eazymuv-os", theme: "os", status: "In deployment",
    tag: "Operating System · 100% Visibility",
    img: IMAGES.coldWarehouseCyan,
    desc: "The Eazymuv Operating System — a single, real-time operating view across factory, warehouse and logistics.",
  },
];

export default function Products() {
  return (
    <Layout>
      <SEO title="Products Overview" description="The Eazymuv product ecosystem: EazyMS for warehouse & factory management and EazyOS for 100% operating visibility." />
      <PageHeader eyebrow="Product Ecosystem" title={<>The products behind the service</>} subtitle="EazyMS and EazyOS are the product surfaces of the Eazymuv ecosystem — one runs the floor, the other gives you 100% visibility across it." image={IMAGES.coldWarehouse} imageAlt="Cold storage warehouse" />
      <section className="max-w-[1600px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-ez-text border border-ez-text">
          {products.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.1}>
              <Link to={p.to} data-testid={`products-card-${p.name.toLowerCase()}`} className="group block bg-white h-full">
                <div className="relative h-72 overflow-hidden">
                  <img src={p.img} alt={p.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                  <div className={`absolute inset-0 ${p.theme === "zoom" ? "bg-zoom-teal/30" : "bg-ms-yellow/10"}`} />
                  <div className="absolute top-4 left-4"><StatusBadge status={p.status} /></div>
                </div>
                <div className="p-8 md:p-10">
                  <div className="font-mono-ez text-xs uppercase tracking-widest text-ez-text/50 mb-3">{p.tag}</div>
                  <div className="flex items-center justify-between">
                    <span className={`font-display text-5xl uppercase tracking-tighter ${p.theme === "zoom" ? "text-zoom-teal" : "text-ez-text"}`}>{p.name}</span>
                    <ArrowUpRight size={30} weight="bold" className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </div>
                  <p className="mt-5 text-ez-text/70 leading-relaxed">{p.desc}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </Layout>
  );
}
